export function autoLogoColor(src) {
  return new Promise((res) => {
    if (!src) {
      res(null);
      return;
    }
    const img = new Image();
    let _dn = false;
    const _proc = () => {
      if (_dn) return;
      _dn = true;
      try {
        const c = document.createElement('canvas');
        c.width = img.naturalWidth || 120;
        c.height = img.naturalHeight || 120;
        const x = c.getContext('2d');
        x.drawImage(img, 0, 0, c.width, c.height);
        const d = x.getImageData(0, 0, c.width, c.height).data;
        const bk = {};
        for (let i = 0; i < d.length; i += 4) {
          const r = d[i],
            g = d[i + 1],
            bl = d[i + 2],
            a = d[i + 3];
          if (a < 200) continue;
          const mx = Math.max(r, g, bl),
            mn = Math.min(r, g, bl);
          const sat = mx === 0 ? 0 : (mx - mn) / mx;
          const lum = (r + g + bl) / 3;
          if (sat < 0.35 || lum > 235 || lum < 25) continue;
          const k = Math.round(r / 32) + '-' + Math.round(g / 32) + '-' + Math.round(bl / 32);
          const o = bk[k] || (bk[k] = { n: 0, r: 0, g: 0, b: 0, s: 0 });
          o.n++;
          o.r += r;
          o.g += g;
          o.b += bl;
          o.s += sat;
        }
        let best = null,
          bs = -1;
        for (const k in bk) {
          const o = bk[k];
          const sc = o.n * (o.s / o.n);
          if (sc > bs) {
            bs = sc;
            best = o;
          }
        }
        if (!best) {
          res(null);
          return;
        }
        const r = Math.round(best.r / best.n),
          g = Math.round(best.g / best.n),
          bl = Math.round(best.b / best.n);
        res('#' + [r, g, bl].map((v) => v.toString(16).padStart(2, '0')).join(''));
      } catch (e) {
        res(null);
      }
    };
    img.onload = _proc;
    img.onerror = () => {
      if (!_dn) {
        _dn = true;
        res(null);
      }
    };
    img.src = src;
    if (img.complete && img.naturalWidth) _proc();
  });
}
